/**
 * Post Module
 * Handles post-specific features: TOC, reading progress, scroll title
 */

function generateTableOfContents() {
    const postBody = document.getElementById('post-body');
    const tocNav = document.getElementById('table-of-contents');
    const mobileTocNav = document.getElementById('mobile-table-of-contents');
    const tocContainer = document.getElementById('toc-container');
    const headerTocBtn = document.getElementById('header-toc-btn');
    const headerTocBtnMobile = document.getElementById('header-toc-btn-mobile');
    
    if (!postBody || (!tocNav && !mobileTocNav)) return;
    
    const headings = postBody.querySelectorAll('h2, h3');
    
    if (headings.length === 0) {
        if (tocContainer) tocContainer.style.display = 'none';
        if (headerTocBtn) headerTocBtn.style.display = 'none';
        if (headerTocBtnMobile) headerTocBtnMobile.style.display = 'none';
        return;
    }
    
    // Show header TOC buttons if there are headings
    if (headerTocBtn) {
        headerTocBtn.style.display = 'flex';
    }
    if (headerTocBtnMobile) {
        headerTocBtnMobile.classList.remove('hidden');
        headerTocBtnMobile.style.display = 'flex';
    }
    
    let tocHTML = '<ul class="space-y-2 text-sm">';
    
    headings.forEach((heading, index) => {
        if (!heading.id) {
            const id = heading.textContent
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-');
            heading.id = `${id}-${index}`;
        }
        
        addAnchorLink(heading);
        
        const isH3 = heading.tagName === 'H3';
        const indent = isH3 ? 'ml-4' : '';
        
        tocHTML += `
            <li class="${indent}">
                <a href="#${heading.id}" 
                   class="toc-link block py-1 text-gray-600 dark:text-gray-400 hover:text-primary transition-colors border-l-2 border-transparent hover:border-primary pl-3"
                   data-target="${heading.id}">
                    ${heading.textContent}
                </a>
            </li>
        `;
    });
    
    tocHTML += '</ul>';
    if (tocNav) tocNav.innerHTML = tocHTML;
    if (mobileTocNav) mobileTocNav.innerHTML = tocHTML;
    
    initTOCNavigation();
    initTOCActiveTracking(headings);
}

function addAnchorLink(heading) {
    if (heading.querySelector('.heading-anchor')) return;
    
    heading.classList.add('heading-with-anchor', 'relative', 'group', 'inline-flex', 'items-center');
    const anchorLink = document.createElement('a');
    anchorLink.href = `#${heading.id}`;
    anchorLink.className = 'heading-anchor ml-2 opacity-0 group-hover:opacity-100 transition-opacity text-primary hover:text-primary/80 no-underline inline-flex items-center';
    anchorLink.innerHTML = '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clip-rule="evenodd"/></svg>';
    anchorLink.title = 'Copy link to clipboard';
    
    anchorLink.addEventListener('click', async (e) => {
        e.preventDefault();
        const url = `${window.location.origin}${window.location.pathname}#${heading.id}`;
        await navigator.clipboard.writeText(url);
        
        const originalTitle = anchorLink.title;
        anchorLink.title = 'Copied!';
        setTimeout(() => anchorLink.title = originalTitle, 2000);
        history.pushState(null, '', `#${heading.id}`);
    });
    
    heading.appendChild(anchorLink);
}

function initTOCNavigation() {
    document.querySelectorAll('.toc-link').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.getElementById(this.dataset.target);
            
            if (target) {
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.pageYOffset - 100,
                    behavior: 'smooth'
                });
                
                history.pushState(null, '', `#${this.dataset.target}`);
                updateActiveTOCLink(this);
            }
        });
    });
}

function updateActiveTOCLink(activeLink) {
    document.querySelectorAll('.toc-link').forEach(l => {
        l.classList.remove('text-primary', 'border-primary', 'font-medium');
        l.classList.add('text-gray-600', 'border-transparent');
    });
    activeLink.classList.remove('text-gray-600', 'border-transparent');
    activeLink.classList.add('text-primary', 'border-primary', 'font-medium');
}

function initTOCActiveTracking(headings) {
    let ticking = false;
    
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            const scrollPosition = window.scrollY + 150;
            
            headings.forEach((heading) => {
                const headingTop = heading.offsetTop;
                const headingBottom = headingTop + heading.offsetHeight;
                
                if (scrollPosition >= headingTop && scrollPosition < headingBottom) {
                    const link = document.querySelector(`.toc-link[data-target="${heading.id}"]`);
                    if (link) updateActiveTOCLink(link);
                }
            });
            
            ticking = false;
        });
        ticking = true;
    });
}

function initReadingProgress() {
    const progressBar = document.getElementById('reading-progress');
    const postBody = document.getElementById('post-body');
    
    if (!progressBar || !postBody) {
        if (progressBar) progressBar.style.display = 'none';
        return;
    }
    
    let ticking = false;
    
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            const postBodyTop = postBody.offsetTop;
            const postBodyHeight = postBody.offsetHeight;
            const windowHeight = window.innerHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollIntoPost = scrollTop - postBodyTop;
            
            let scrollPercentage = 0;
            if (scrollIntoPost > 0) {
                const scrollableHeight = postBodyHeight - windowHeight;
                scrollPercentage = (scrollIntoPost / scrollableHeight) * 100;
            }
            
            progressBar.style.width = `${Math.max(0, Math.min(scrollPercentage, 100))}%`;
            ticking = false;
        });
        ticking = true;
    });
}

function initScrollPostTitle() {
    const headerPostInfo = document.getElementById('header-post-info');
    const headerPostTitle = document.getElementById('header-post-title');
    const headerAuthorImage = document.getElementById('header-author-image');
    
    if (!headerPostInfo || !headerPostTitle || !headerAuthorImage) return;
    
    const postTitle = document.querySelector('.article h1');
    const authorImage = document.querySelector('.article header ul img, .article header .author-avatar img');
    
    if (!postTitle) return;
    
    headerPostTitle.textContent = postTitle.textContent;
    if (authorImage) {
        headerAuthorImage.src = authorImage.src;
        headerAuthorImage.alt = authorImage.alt;
    } else {
        headerAuthorImage.style.display = 'none';
    }
    
    const headerNavItems = document.getElementById('header-nav-items');
    const compactMenu = document.getElementById('header-compact-menu');
    const isPostPage = document.body.classList.contains('post-template');
    
    let ticking = false;
    let isPostInfoVisible = false;
    
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const titleRect = postTitle.getBoundingClientRect();
                const headerHeight = 80;
                const shouldShowPostInfo = titleRect.bottom < headerHeight;
                
                if (shouldShowPostInfo !== isPostInfoVisible) {
                    if (shouldShowPostInfo) {
                        showPostInfo(headerPostInfo, isPostPage);
                    } else {
                        hidePostInfo(headerPostInfo, isPostPage);
                    }
                    isPostInfoVisible = shouldShowPostInfo;
                }
                
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
}

function showPostInfo(headerPostInfo, isPostPage) {
    headerPostInfo.classList.remove('hidden');
    requestAnimationFrame(() => {
        headerPostInfo.classList.remove('opacity-0', 'translate-x-5');
        headerPostInfo.classList.add('opacity-100', 'translate-x-0');
    });
}

function hidePostInfo(headerPostInfo, isPostPage) {
    headerPostInfo.classList.remove('opacity-100', 'translate-x-0');
    headerPostInfo.classList.add('opacity-0', 'translate-x-5');
    setTimeout(() => {
        headerPostInfo.classList.add('hidden');
    }, 300);
}

function initMobileTOC() {
    const headerTocBtn = document.getElementById('header-toc-btn');
    const headerTocBtnMobile = document.getElementById('header-toc-btn-mobile');
    const mobileTocOffcanvas = document.getElementById('mobile-toc-offcanvas');
    const mobileTocPanel = document.getElementById('mobile-toc-panel');
    const mobileTocBackdrop = document.getElementById('mobile-toc-backdrop');
    const mobileTocClose = document.getElementById('mobile-toc-close');
    
    if ((!headerTocBtn && !headerTocBtnMobile) || !mobileTocOffcanvas) return;
    
    const openTOC = () => {
        mobileTocOffcanvas.classList.remove('pointer-events-none');
        mobileTocOffcanvas.classList.add('pointer-events-auto');
        requestAnimationFrame(() => {
            mobileTocBackdrop.classList.remove('opacity-0');
            mobileTocBackdrop.classList.add('opacity-100');
            mobileTocPanel.classList.remove('-translate-x-full');
            mobileTocPanel.classList.add('translate-x-0');
        });
        document.body.style.overflow = 'hidden';
    };
    
    const closeTOC = () => {
        mobileTocBackdrop.classList.remove('opacity-100');
        mobileTocBackdrop.classList.add('opacity-0');
        mobileTocPanel.classList.remove('translate-x-0');
        mobileTocPanel.classList.add('-translate-x-full');
        setTimeout(() => {
            mobileTocOffcanvas.classList.remove('pointer-events-auto');
            mobileTocOffcanvas.classList.add('pointer-events-none');
            document.body.style.overflow = '';
        }, 300);
    };
    
    if (headerTocBtn) {
        headerTocBtn.addEventListener('click', openTOC);
    }
    if (headerTocBtnMobile) {
        headerTocBtnMobile.addEventListener('click', openTOC);
    }
    mobileTocClose.addEventListener('click', closeTOC);
    mobileTocBackdrop.addEventListener('click', closeTOC);
    
    // Close on TOC link click
    const mobileTocLinks = document.querySelectorAll('#mobile-table-of-contents .toc-link');
    mobileTocLinks.forEach(link => {
        link.addEventListener('click', () => {
            setTimeout(closeTOC, 300);
        });
    });
}
